<template>
  <d-card class="card-small mb-3">
    <d-card-header class="border-bottom">
      <h6 class="m-0">{{ title }}</h6>
    </d-card-header>

    <d-card-body class="px-0">
      <d-list-group flush>
        <d-list-group-item class="p-3">
          <d-button class="btn-info btn-block" @click="toggleSpam()">
            <span v-if="model.status == 'spam'" >Desmarcar como spam</span>
            <span v-else >Marcar como spam</span>
          </d-button>
          <d-button v-if="showAttach" class="btn-success btn-block" @click="openAssignModal()">Atribuir</d-button>
        </d-list-group-item>

      </d-list-group>
    </d-card-body>

    <d-card-footer class="border-top">
      <d-link class="btn-secondary btn btn-block text-white" :to="{ name: 'admin-lead-list', params: { page: 1 }}">Voltar</d-link>
    </d-card-footer>
  </d-card>
</template>

<script>
import { MODEL } from '_modules/lead/components/LeadModel';
import { mapActions } from 'vuex';

export default {
  name: 'sidebar-actions',
  props: {
    title: {
      type: String,
      default: 'Ações',
    },
    model: {
      type: Object,
      default: () => MODEL,
    },
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
    showAttach() {
      if (this.isAdmin) {
        return true;
      }
      return false;
    },
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions([
      'checkAdmin',
    ]),
    toggleSpam() {
      this.$emit('toggleSpam', this.model);
    },
    openAssignModal() {
      this.$emit('openAssignModal', this.model);
    },
  },
  mounted() {
    this.checkAdmin();
  },
};
</script>
<style lang="scss" scoped>
i.material-icons {
  top: 5px;
}
</style>
